import React from 'react';
import PropertyCard from '../components/PropertyCard';
import HeroSection from '../components/HeroSection';
import StaysInSpotlight from '../components/StaysInSpotlight';
import HappeningThisWeek from '../components/HappeningThisWeek';
import PawStories from '../components/PawStories';
import MeetTheFounders from '../components/MeetTheFounders';

const Home = () => {
  return (
    <div className="bg-[#FAF7F2] min-h-screen">
      {/* Hero Section */}
      <HeroSection mode="all" />
      
      {/* Stays in Spotlight */}
      <StaysInSpotlight />

      
      {/* Happening this week */}
      <HappeningThisWeek />
      
      {/* Paw Stories */}
      <PawStories />
      
      {/* Meet the founders */}
      <MeetTheFounders />
    </div>
  );
};

export default Home; 